import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'tanok';

import * as a from './../../../libs/actions';
import * as c from './../../../libs/constants';
import * as u from './../../../libs/utils';
import * as aggr from './../../../libs/aggregation';

import { Icon } from '../../ui/icon';

// styles
import css from './chatButton.sss';

// images
import ChatIconSvg from './images/chat.icon.svg';


class ChatButtonView extends React.Component {
    static propTypes = {
        isInBuyerCabinet: PropTypes.bool,
        isThereNewMessages: PropTypes.bool,
        chatVisible: PropTypes.bool,
        authUser: PropTypes.bool,
        openDialog: PropTypes.func,
    };

    componentDidMount() {
        document.addEventListener('keydown', this.handleButtonKeyPress);
    }

    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleButtonKeyPress);
    }

    handleButtonKeyPress = ({ which, ctrlKey }) => {
        if (which === c.KEY_CODE_ENTER && !this.props.chatVisible && ctrlKey) {
            event.preventDefault();
            this.props.openDialog();
        }
        return true;
    }

    handleButtonClick = () => {
        this.props.openDialog();
        const payload = { action: c.ANALCS_ACTION_START_CHAT, params: {} };
        if (this.props.authUser) payload.params.auth = true;
        else payload.params.noauth = true;

        this.props.send(a.TR_SEND_ANALITICS_ACTION, payload);
    }

    render() {
        const { props } = this;
        return (
            <span
                onClick={this.handleButtonClick}
                onKeyDown={this.handleButtonKeyPress}
                className={props.isInBuyerCabinet ? css.rootCabinet : css.root}
                data-qaid='besida_tool_block'
                key='mainButtonBesidaContainer'
            >
                <span className={css.iconHolder}>
                    <Icon
                        className={css.icon}
                        glyph={ChatIconSvg}
                    />
                    {props.isThereNewMessages && (
                        <span
                            className={css.indicator}
                            data-qaid='circle_icon'
                        />
                    )}
                    {/* TODO if get count change for count indicator
                        <span className={css.countIndicator} data-qaid='circle_icon'/>
                    */}
                </span>
            </span>
        );
    }
}

const mapStateToProps = (state) => ({
    isInBuyerCabinet: state.get('isInBuyerCabinet'),
    isThereNewMessages: aggr.isThereNewMessages(
        u.getSocketStore(state).get('chats')),
    chatVisible: state.get('visible'),
    authUser: !!state.get('userId'),
    locale: state.get('locale')
});


export const ChatButton = connect(mapStateToProps)(ChatButtonView);
